import { motion } from 'framer-motion'
import { Shield, CheckCircle, AlertTriangle, Clock } from 'lucide-react'
import { PageHeader, fadeUp } from '@personic/shared'
import { buildBreadcrumbs } from '@/config/routes'

export default function Status() {
  const breadcrumbs = buildBreadcrumbs('/settings/compliance/status')

  const indicators = [
    { label: 'Attestation Frameworks', status: 'healthy', detail: 'All frameworks acknowledged', icon: CheckCircle },
    { label: 'Data Processing', status: 'healthy', detail: 'Within compliance bounds', icon: Shield },
    { label: 'Audit Trail', status: 'healthy', detail: 'Continuous logging active', icon: Clock },
    { label: 'Renewal Status', status: 'attention', detail: 'Review scheduled Q2 2026', icon: AlertTriangle },
  ]

  return (
    <div>
      <PageHeader
        title="Compliance Status"
        description="Overview of your organization's compliance posture and attestation health."
        breadcrumbs={breadcrumbs}
      />

      <div className="space-y-6 max-w-4xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {indicators.map((ind) => (
            <motion.div
              key={ind.label}
              variants={fadeUp} initial="hidden" animate="visible"
              className="rounded-xl border border-warm-200 bg-white p-5"
            >
              <div className="flex items-start gap-3">
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                  ind.status === 'healthy' ? 'bg-sage-50' : 'bg-amber-50'
                }`}>
                  <ind.icon className={`w-4 h-4 ${
                    ind.status === 'healthy' ? 'text-sage-600' : 'text-amber-600'
                  }`} />
                </div>
                <div>
                  <h3 className="text-sm font-medium text-midnight-800">{ind.label}</h3>
                  <p className="text-xs text-warm-500 mt-0.5">{ind.detail}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div variants={fadeUp} initial="hidden" animate="visible" className="rounded-xl border border-warm-200 bg-white p-6">
          <h2 className="font-heading font-semibold text-midnight-800 mb-3">Quick Actions</h2>
          <div className="flex flex-wrap gap-3">
            <a href="/settings/compliance/audit" className="px-4 py-2 rounded-lg border border-warm-200 text-sm text-warm-700 hover:border-copper-300 hover:text-copper-700 transition-colors">
              View Audit Log
            </a>
            <a href="/settings/compliance/reports" className="px-4 py-2 rounded-lg border border-warm-200 text-sm text-warm-700 hover:border-copper-300 hover:text-copper-700 transition-colors">
              Generate Report
            </a>
          </div>
        </motion.div>
      </div>
    </div>
  )
}
